export default "__VITE_ASSET__31611510__"